export default __webpack_public_path__ + "static/media/map_marker.3b9586c3.svg";